import { FC } from 'react';

type Props = {
  message: string;
  type: 'danger' | 'success';
};

const Notify: FC<Props> = ({ message, type }) => {
  return <div className={`alert alert-${type} text-center`}>{message}</div>;
};

export default Notify;
